export const GRS_PRICE_FACET_WAREHOUSE_KEY = 'pricefacetwarehouse';
